__webpack_require__.p = "/Mandi_Solone_Portfolio/";